import type { StatsigListingsConfig } from './types';

/**
 * Whether Statsig client should be initialized.
 */
export const shouldInitStatsig = ({ clientKey, stableId, deactivateSdk }: StatsigListingsConfig): boolean =>
  Boolean(clientKey && stableId && !deactivateSdk);

/**
 * Build Statsig user object for listings page.
 * Uses stableId from edge for consistent user identification.
 */
export const getUser = (
  stableId?: string,
  custom?: Record<string, string | number | boolean | undefined>,
) => {
  const hasCustomProps = custom && Object.keys(custom).length > 0;

  return {
    customIDs: stableId ? { stableID: stableId } : undefined,
    custom: hasCustomProps ? custom : undefined,
  };
};

/**
 * Build Statsig options object.
 * Overrides SDK's internal stableID with ours from edge (matching ebui pattern).
 */
export const getOptions = (stableId?: string, environmentTier?: string) => ({
  ...(environmentTier && { environment: { tier: environmentTier } }),
  ...(stableId && { overrideStableID: stableId }),
});
